/* eslint @typescript-eslint/no-explicit-any: ["off"] */
export const createQueryParams = (obj: any): string => {
    const modified = Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null)) as Record<string, string>;
    const params = new URLSearchParams(modified);
    const queryString = params.toString()
    return queryString ? `?${queryString}` : "";
};

export default createQueryParams;
